import { Expose, Exclude } from 'class-transformer';
import { UID } from '@saliente/library';

import { Maybe, Scalars } from '../general/gql-codegen.types'


export type Accounts_GetViesVatDataUsingGetQuery = {
  accounts?: Maybe<{
    getViesVatDataUsingGET?:
    Maybe<{
      address?: Maybe<string>,
      country?: Maybe<string>, found?: Maybe<boolean>,
      name?: Maybe<string>,
      requestDate?: Maybe<string>,
      resultCode?: Maybe<string>,
      resultMessage?: Maybe<string>,
      validCountry?: Maybe<boolean>,
      vatNumber?: Maybe<string>
    }>
  }>
};

export class PartnerModel {

  constructor() {
    this.id = UID();
  }

  @Expose({ name: 'externalId' })
  //@Exclude({ toPlainOnly: true })
  public id: string;

  public clientExternalId: string;

  public isLegalPerson: boolean = true;

  @Exclude()
  get partnerType(): string {
    return this.isLegalPerson ? 'PJ' : 'PF';
  }
  set partnerType(value: string) {
    this.isLegalPerson = (value == 'PJ');
  }

  public partnerName: string;
  public fiscalNumber: string;
  public registrationNumber: string;
  public taxAttribute: string;
  public taxCode: string;

  public region: string;
  @Expose({ name: 'country_code' })
  public countryCode: string;

  @Expose({ name: 'country_name' })
  @Exclude({ toPlainOnly: true })
  public countryName: string;

  public county: string;
  public city: string;
  public addressDetails: string;
	public saftPrefix: string;

  public socialCity: string;
  public socialCounty: string;
  public socialCountryName: string;
  public socialAddressDetails: string;
  public sameSocialAddressWithAddress: boolean;

  public static typeProvider() {
    return PartnerModel;
  }

}